import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
import { EidButton, WarningModal } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'
import { useQuery } from 'packages/core'
import { useDeleteAzureApplicationRole } from 'hooks'
import { Button } from 'components'

const DeleteAzureApplicationRole = ({
    item,
    drawerView,
    identifier = 'globalRightId',
    ...rest
}) => {
    const { t } = useTranslation()
    const query = useQuery()
    const history = useHistory()

    const [showConfirm, setShowConfirm] = useState(false)
    const [deleteApplicationRole, { isLoading: isDeleting }] =
        useDeleteAzureApplicationRole()

    const handleDelete = () => {
        deleteApplicationRole({
            id: item[identifier],
            resourceSystemModuleId: item.resourceSystemModuleId,
        }).then(() => {
            setShowConfirm(false)
            query.delete('appRightId')
            history.push(`${history.location.pathname}?${query.toString()}`)
        })
    }

    return (
        <>
            {!drawerView ? (
                <Button.Delete
                    item={item}
                    onClick={() => setShowConfirm(true)}
                    disabled={item.isExpired}
                    {...rest}
                />
            ) : (
                <Box width="150px" marginLeft={'40px'}>
                    <EidButton.DrawerActionButton
                        disabled={item.isExpired}
                        fontColor="#ffffff"
                        bgColor="#E40000"
                        width="100%"
                        onClick={() => setShowConfirm(true)}
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            height={'12px'}
                            width={'12px'}
                        >
                            <Icon
                                name="DeleteX"
                                fill="#ffffff"
                                color="#ffffff"
                            />
                        </Box>
                        <Box
                            display="flex"
                            alignItems="center"
                            marginLeft="10px"
                        >
                            <Typography style={{ color: '#ffffff' }}>
                                {t('Delete')}
                            </Typography>
                        </Box>
                    </EidButton.DrawerActionButton>
                </Box>
            )}
            <WarningModal
                title={t('Delete') + ' ' + item?.friendlyName}
                description={t('AppRoleDeleteMessage')}
                yesLabel={t('Delete')}
                noLabel={t('Cancel')}
                open={showConfirm}
                cancel={() => setShowConfirm(false)}
                proceeding={isDeleting}
                proceed={handleDelete}
            />
        </>
    )
}

DeleteAzureApplicationRole.defaultProps = {
    drawerView: false,
}
export default DeleteAzureApplicationRole
